import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { approverApi } from '../../lib/api.js';
import { useToast } from '../../hooks/useToast.jsx';
import { Card, CardContent } from '../../components/ui/Card.jsx';
import { Plane, Info } from 'lucide-react';
import { visaTypeLabel } from '../../lib/visas.js';

export default function VisaApprovalQueuePage() {
  const toast = useToast();
  const navigate = useNavigate();
  const [visas, setVisas] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    approverApi.getVisaQueue()
      .then((res) => setVisas(res.visas || []))
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="max-w-3xl mx-auto space-y-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight text-foreground">Visa Approvals</h1>
        <p className="mt-1 text-sm text-muted-foreground">Visa requests awaiting your decision.</p>
      </div>
      {loading ? (
        <div className="flex items-center justify-center py-20"><div className="h-6 w-6 animate-spin rounded-full border-[2.5px] border-border border-t-primary" /></div>
      ) : visas.length === 0 ? (
        <Card><CardContent className="flex items-start gap-3 py-8">
          <Info className="mt-0.5 h-5 w-5 text-muted-foreground shrink-0" />
          <p className="text-sm text-muted-foreground">Nothing awaiting your approval right now.</p>
        </CardContent></Card>
      ) : (
        <div className="space-y-3">
          {visas.map((v) => (
            <Card key={`${v.partitionKey}-${v.rowKey}`} className="cursor-pointer hover:border-primary/40 transition-colors"
              onClick={() => navigate(`/visa-approvals/${encodeURIComponent(v.partitionKey)}/${encodeURIComponent(v.rowKey)}`)}>
              <CardContent className="flex items-center gap-4 py-4">
                <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary/10"><Plane className="h-5 w-5 text-primary" /></div>
                <div className="flex-1 min-w-0">
                  <div className="font-medium text-foreground">{v.requesterName || v.requesterEmail}</div>
                  <div className="text-xs text-muted-foreground mt-0.5">
                    {visaTypeLabel(v.visaType)}{v.neededBy ? ` · needed by ${v.neededBy}` : ''}
                  </div>
                </div>
                <span className="text-xs font-medium text-primary">Review →</span>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
